import React from 'react';
type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  tone?: 'dark' | 'light';
  align?: 'center' | 'left';
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  title,
  subtitle,
  tone = 'dark',
  align = 'center',
  as: Tag = 'h2'
}: SectionHeadingProps) {
  const titleColor = tone === 'dark' ? 'text-white' : 'text-ink-900';
  const subColor = tone === 'dark' ? 'text-white/70' : 'text-ink-600';
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <header className={`max-w-3xl ${alignment}`} data-id="element-61" data-mp="gjq2lywwmlj9">
      <Tag className={`font-display text-[28px] font-bold uppercase leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl ${titleColor}`} data-id="element-62" data-mp="glj6j6g4urnk">
        {title}
      </Tag>
      {subtitle ? <p className={`mt-4 text-[15px] leading-relaxed sm:text-lg ${subColor}`} data-id="element-63" data-mp="6rahwtu83iuo">{subtitle}</p> : null}
    </header>;
}